export const isRTL = (): boolean => document.body.getAttribute('dir') === 'rtl'

export const direction = (): string => document.body.getAttribute('dir')